import React from 'react';
import EmployeesContext from './EmployeesContext';

export default function useEmployees() {
    return React.useContext(EmployeesContext);
}
